/**
 * cen模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const cen = {
  //分页
  pageCen(params) {
    return $http.post(`${global.API_URL}/sme/cen/page`,params);
  },
  //详情
  queryCenByCenId(params) {
    return $http.post(`${global.API_URL}/sme/cen/queryCenByCenId`,params);
  }
}

export default cen;



// WEBPACK FOOTER //
// ./src/api/cen.js